import { NewsCategory } from "../../../interfaces/News";
import { parseServerDate } from "./serverDate";

/**
 * Editoria → rótulo e cor. Editoria é rótulo, não permissão (design D1): ela filtra e colore o
 * feed, e nunca decide quem vê.
 *
 * As cores saem dos badges de status do Design System (§4.4) — cada editoria com um par
 * light/dark, porque status nunca depende só de cor e nenhum elemento fica só para o light.
 */
export const NEWS_CATEGORIES: {
  value: NewsCategory;
  label: string;
  hint: string;
  chip: string;
}[] = [
  {
    value: NewsCategory.Novidades,
    label: "Novidades",
    hint: "O que mudou no NINA e nas ferramentas",
    chip: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300",
  },
  {
    value: NewsCategory.Comunicado,
    label: "Comunicado",
    hint: "RH, políticas e avisos formais",
    chip: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
  },
  {
    value: NewsCategory.Pessoas,
    label: "Pessoas",
    hint: "Entradas, movimentações e reconhecimento",
    chip: "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300",
  },
  {
    value: NewsCategory.Operacao,
    label: "Operação",
    hint: "Cliente, entrega, processo e manutenção",
    chip: "bg-gray-100 text-gray-600 dark:bg-navy-700 dark:text-gray-300",
  },
];

export const categoryOf = (c: NewsCategory) =>
  NEWS_CATEGORIES.find((x) => x.value === c) ?? NEWS_CATEGORIES[1];

/**
 * Data de publicação em pt-BR; rascunho não tem data e a UI diz isso, em vez de mostrar vazio.
 *
 * Passa pelo `parseServerDate` porque o instante chega sem fuso: lido como hora local, um post
 * publicado depois das 21 h em BRT aparecia com a data do dia seguinte.
 */
export const publishedLabel = (iso: string | null) => {
  const d = parseServerDate(iso);
  return d
    ? d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" })
    : "Rascunho";
};
